import React from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  ConfirmationModal,
  TailwindToaster,
  Pagination,
  MeetingsList,
  MeetingItem,
  FillMOM,
} from "../../components";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";

import axios from "../../api/axios";

const Meetings = () => {
  const state = useSelector((state) => state.UserReducer);
  const navigate = useNavigate();
  const meetingUrl = "/meetings";

  const [refreshData, setRefreshData] = React.useState(true);
  const [meetingData, setMeetingsData] = React.useState([]);
  const [meetingServerData, setMeetingsServerData] = React.useState([]);
  const [currentPageIndex, setCurrentPageIndex] = React.useState(0);
  const [totalPages, setTotalPages] = React.useState(1);
  const [totalRecords, setTotalRecords] = React.useState(0);
  const [recordsPerPage, setRecordsPerPage] = React.useState(25);

  const [spotlightMeeting, setSpotlightMeeting] = React.useState(null);
  const [highlightedMeetingData, setHighlightedMeetingData] = React.useState(
    {},
  );

  const selectMeeting = (meetingId) => {
    if (meetingId === spotlightMeeting) setSpotlightMeeting(null);
    else setSpotlightMeeting(meetingId);
  };

  const [meetingInfoRefresh, setMeetingInfoRefresh] = React.useState(false);

  const getMeetingInfo = (meetingId) => {
    setMeetingInfoRefresh(true);
    try {
      axios
        .get(meetingUrl + "/" + meetingId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.meeting) {
            setHighlightedMeetingData(response.data.meeting);
          }
          setMeetingInfoRefresh(false);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
          setMeetingInfoRefresh(false);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
      setMeetingInfoRefresh(false);
    }
  };

  const inviteAction = (status, itemId) => {
    setMeetingInfoRefresh(true);
    try {
      axios
        .put(meetingUrl + "/" + itemId, JSON.stringify({ status }), {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.status === "success" && response?.data?.meeting) {
            toast.success(response.data.message);
            setHighlightedMeetingData(response.data.meeting);
          } else {
            toast.error(response.data.message);
          }
          setMeetingInfoRefresh(false);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
          setMeetingInfoRefresh(false);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
      setMeetingInfoRefresh(false);
    }
  };

  React.useEffect(() => {
    if (spotlightMeeting !== null) getMeetingInfo(spotlightMeeting);
    else setHighlightedMeetingData({});
  }, [spotlightMeeting]);

  const [listType, setListType] = React.useState("now");

  const getMeetings = () => {
    // console.log(type);
    try {
      axios
        .get(meetingUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
            "Access-Control-Allow-Origin": "*",
          },
          params: {
            listType,
          },
        })
        .then((response) => {
          if (response?.data?.meetings?.length >= 0) {
            setMeetingsData(response.data.meetings);
            setMeetingsServerData(response.data.meetings);
            if (response.data.meetingCount?.length > 0) {
              setTotalRecords(response.data.meetingCount[0].meetingCnt);
              setTotalPages(
                Math.ceil(
                  response.data.meetingCount[0].meetingCnt / recordsPerPage,
                ),
              );
            } else {
              setTotalRecords(0);
              setTotalPages(0);
            }
          }
          setRefreshData(false);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          setRefreshData(false);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
      setRefreshData(false);
    }
  };

  const updateMomServer = (meetingId, momContents) => {
    setMeetingInfoRefresh(true);
    try {
      axios
        .put(meetingUrl + "/" + meetingId, JSON.stringify({ momContents }), {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.status === "success" && response?.data?.meeting) {
            toast.success(response.data.message);
            getMeetings();
          } else {
            toast.error(response.data.message);
          }
          setMeetingInfoRefresh(false);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
          setMeetingInfoRefresh(false);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
      setMeetingInfoRefresh(false);
    }
    closeConfirmation();
  };

  const [momPopupId, setMomPopup] = React.useState(null);
  const updateMomConfirmation = (proceedFlag, momContents) => {
    console.log(momContents);
    if (proceedFlag) updateMomServer(momPopupId, momContents);
    //
  };

  const [meetingItem, setMeetingItem] = React.useState({});
  React.useEffect(() => {
    const meeting = meetingServerData.filter((item) => {
      return item._id === momPopupId;
    });
    setMeetingItem(meeting[0]);
  }, [momPopupId]);

  const setAction = (itemId, action) => {
    if (action === "Delete") setDeletePopup(itemId);
    else if (action === "MOM") setMomPopup(itemId);
    else if (action === "Edit") navigate("/meetings/edit/" + itemId);
  };

  const [deletePopupId, setDeletePopup] = React.useState(null);
  const deleteMeetings = (meetingId) => {
    setRefreshData(true);
    try {
      axios
        .delete(meetingUrl + "/" + meetingId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
            getMeetings();
            setRefreshData(false);
          } else toast.error(response?.data?.message);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const confirmDelete = (meetingId) => {
    setDeletePopup(meetingId);
  };
  const closeConfirmation = () => {
    setDeletePopup(null);
    setMomPopup(null);
  };
  const deleteConfirmation = (canDelete) => {
    if (canDelete) deleteMeetings(deletePopupId);
    setDeletePopup(null);
  };

  const copyEmailToClipboard = (email) => {
    navigator.clipboard.writeText(email).then(() => {
      toast.success("Copied Email to Clipboard");
    });
  };

  const changePageCallback = (targetPageIndex) => {
    setCurrentPageIndex(targetPageIndex);
  };

  const changeDisplayRecordCountCallback = (targetRecordsPerPage) => {
    setRecordsPerPage(targetRecordsPerPage);
  };

  const [pageTitle, setPageTitle] = React.useState("Lands & Lands ERP");
  React.useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);

  const [searchTerm, setSearchTerm] = React.useState("");

  React.useEffect(() => {
    setRefreshData(true);
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    const delayDebounceFn = setTimeout(() => {
      getMeetings();
    }, 500);
    setPageTitle("Meetings - L&L ERP");
    return () => clearTimeout(delayDebounceFn);
  }, [recordsPerPage, currentPageIndex, searchTerm, listType]);

  return (
    <>
      {deletePopupId && (
        <ConfirmationModal
          actionName={"Delete"}
          deleteConfirmation={deleteConfirmation}
          closeConfirmation={closeConfirmation}
          moduleName={"Meeting"}
          itemName={"Meeting"}
        />
      )}
      {meetingItem?._id && (
        <FillMOM
          meetingItem={meetingItem}
          closeConfirmation={closeConfirmation}
          completeConfirmation={updateMomConfirmation}
        />
      )}
      <div className='min-h-full'>
        <main className='relative'>
          <div className='max-w-8xl mx-auto py-6 sm:px-6 lg:px-8'>
            <div className='lg:flex lg:items-center justify-between'>
              <div className='flex-1 min-w-0 px-5 lg:px-0'>
                <h2 className='mt-4 ml-1 text-xl font-semibold leading-7 text-gray-dark sm:text-xl '>
                  Meetings
                </h2>
              </div>
              <div className='flex space-x-2 mt-3 sm:ml-4 ml-5 sm:mr-0 mr-5'>
                <div className=''>
                  {listType === "now" ? (
                    <button
                      type='button'
                      onClick={(event) => {
                        event.preventDefault();
                        setSpotlightMeeting(null);
                        setListType("past");
                      }}
                      className='inline-flex duration-300 items-center mt-.5 px-4 py-2 border border-gray-300 rounded-sm shadow-sm sm:text-xs text-sm font-medium text-black bg-yellow hover:bg-gray-dark hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'>
                      Past Meetings
                    </button>
                  ) : (
                    <button
                      type='button'
                      onClick={(event) => {
                        event.preventDefault();
                        setSpotlightMeeting(null);
                        setListType("now");
                      }}
                      className='inline-flex duration-300 items-center mt-.5 px-4 py-2 border border-gray-300 rounded-sm shadow-sm sm:text-xs text-sm font-medium text-black bg-yellow hover:bg-gray-dark hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'>
                      Present Meetings
                    </button>
                  )}
                </div>
                {/* <div className='col-span-3 w-40'>
                    <input
                      type='text'
                      name='search'
                      id='search'
                      onChange={(e) => {
                        setCurrentPageIndex(0);
                        setSearchTerm(e.target.value);
                      }}
                      placeholder='Search'
                      maxLength='20'
                      className='focus:ring-yellow-2 text-sm focus:border-yellow-2 block w-full shadow-sm sm:text-xs read-only:bg-gray-100 read-only:opacity-50 rounded-sm'
                    />
                  </div> */}
                <div>
                  <span className=''>
                    <Link to='/meetings/create'>
                      <button
                        type='button'
                        className='inline-flex duration-300 items-center mt-.5 px-4 py-2 border border-gray-300 rounded-sm shadow-sm sm:text-xs text-sm font-medium text-black bg-yellow hover:bg-gray-dark hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'>
                        Create
                      </button>
                    </Link>
                  </span>
                </div>
              </div>
            </div>
            <div className='px-4 py-3 sm:px-0'>
              <TailwindToaster />
              <div className='hidden md:block shadow-lg overflow-x-auto w-full'>
                {!refreshData ? (
                  <div className='grid grid-cols-4 gap-4'>
                    <div className='col-span-1 py-2 px-2 border-r-2 border-gray-100 rounded-sm h-full flex flex-col justify-between'>
                      <div className=''>
                        <MeetingsList
                          spotlightMeeting={spotlightMeeting}
                          meetingData={meetingServerData}
                          setSpotlight={selectMeeting}
                          setAction={setAction}
                          listType={listType}
                        />
                      </div>
                    </div>
                    <div className='col-span-3 p-1 rounded-sm'>
                      <MeetingItem
                        selectedItemData={highlightedMeetingData}
                        infoRefresh={meetingInfoRefresh}
                        listType={listType}
                        inviteAction={inviteAction}
                      />
                    </div>
                  </div>
                ) : (
                  <div className='grid grid-cols-4 gap-4 py-2 px-1'>
                    <div className='col-span-1 flex flex-col space-y-2 p-1 opacity-75'>
                      <div className='flex flex-col px-2 py-3 space-y-2 rounded-sm items-left animate-pulse duration-100 justify-center bg-gray-100'>
                        <div className='flex flex-row gap-2'>
                          <div className='w-full bg-yellow-3 h-6 rounded-sm '></div>
                        </div>
                        <div className='flex flex-nowrap space-x-3'>
                          <div className='w-full bg-gray-200 h-4 rounded-sm '></div>
                          <div className='w-full bg-gray-200 h-4 rounded-sm '></div>
                        </div>
                        <div className='flex flex-row space-x-3'>
                          <div className='w-8/12 bg-gray-200 h-5 rounded-sm '></div>
                          <div className='w-4/12 bg-yellow-2 h-5 rounded-sm '></div>
                        </div>
                      </div>
                      <div className='flex flex-col px-2 py-3 space-y-2 rounded-sm items-left animate-pulse duration-200 justify-center bg-gray-100'>
                        <div className='flex flex-row gap-2'>
                          <div className='w-full bg-yellow-3 h-6 rounded-sm '></div>
                        </div>
                        <div className='flex flex-nowrap space-x-3'>
                          <div className='w-full bg-gray-200 h-4 rounded-sm '></div>
                          <div className='w-full bg-gray-200 h-4 rounded-sm '></div>
                        </div>
                        <div className='flex flex-row space-x-3'>
                          <div className='w-8/12 bg-gray-200 h-5 rounded-sm '></div>
                          <div className='w-4/12 bg-yellow-2 h-5 rounded-sm '></div>
                        </div>
                      </div>
                      <div className='flex flex-col px-2 py-3 space-y-2 rounded-sm items-left animate-pulse justify-center bg-gray-100'>
                        <div className='flex flex-row gap-2'>
                          <div className='w-full bg-yellow-3 h-6 rounded-sm '></div>
                        </div>
                        <div className='flex flex-nowrap space-x-3'>
                          <div className='w-full bg-gray-200 h-4 rounded-sm '></div>
                          <div className='w-full bg-gray-200 h-4 rounded-sm '></div>
                        </div>
                        <div className='flex flex-row space-x-3'>
                          <div className='w-8/12 bg-gray-200 h-5 rounded-sm '></div>
                          <div className='w-4/12 bg-yellow-2 h-5 rounded-sm '></div>
                        </div>
                      </div>
                      <div className='flex flex-col px-2 py-3 space-y-2 rounded-sm items-left animate-pulse  justify-center bg-gray-100'>
                        <div className='flex flex-row gap-2'>
                          <div className='w-full bg-yellow-3 h-6 rounded-sm '></div>
                        </div>
                        <div className='flex flex-nowrap space-x-3'>
                          <div className='w-full bg-gray-200 h-4 rounded-sm '></div>
                          <div className='w-full bg-gray-200 h-4 rounded-sm '></div>
                        </div>
                        <div className='flex flex-row space-x-3'>
                          <div className='w-8/12 bg-gray-200 h-5 rounded-sm '></div>
                          <div className='w-4/12 bg-yellow-2 h-5 rounded-sm '></div>
                        </div>
                      </div>
                      <div className='flex flex-col px-2 py-3 space-y-2 rounded-sm items-left animate-pulse justify-center bg-gray-100'>
                        <div className='flex flex-row gap-2'>
                          <div className='w-full bg-yellow-3 h-6 rounded-sm '></div>
                        </div>
                        <div className='flex flex-nowrap space-x-3'>
                          <div className='w-full bg-gray-200 h-4 rounded-sm '></div>
                          <div className='w-full bg-gray-200 h-4 rounded-sm '></div>
                        </div>
                        <div className='flex flex-row space-x-3'>
                          <div className='w-8/12 bg-gray-200 h-5 rounded-sm '></div>
                          <div className='w-4/12 bg-yellow-2 h-5 rounded-sm '></div>
                        </div>
                      </div>
                      <div className='flex flex-col px-2 py-3 space-y-2 rounded-sm items-left animate-pulse justify-center bg-gray-100'>
                        <div className='flex flex-row gap-2'>
                          <div className='w-full bg-yellow-3 h-6 rounded-sm '></div>
                        </div>
                        <div className='flex flex-nowrap space-x-3'>
                          <div className='w-full bg-gray-200 h-4 rounded-sm '></div>
                          <div className='w-full bg-gray-200 h-4 rounded-sm '></div>
                        </div>
                        <div className='flex flex-row space-x-3'>
                          <div className='w-8/12 bg-gray-200 h-5 rounded-sm '></div>
                          <div className='w-4/12 bg-yellow-2 h-5 rounded-sm '></div>
                        </div>
                      </div>
                    </div>
                    <div className='col-span-3'></div>
                  </div>
                )}
              </div>
              <div className='block md:hidden'>
                {!refreshData ? (
                  <div className='grid grid-cols-1 gap-1'>
                    {meetingServerData.length > 0 ? (
                      <div className=''>
                        {meetingServerData.map((item) => (
                          <div
                            key={item?.customerID}
                            className='px-1 py-1 shadow border-b-2 border-gray-100'>
                            <div className='grid grid-cols-6'>
                              <div
                                className='col-span-4'
                                onClick={(e) => {
                                  navigate(meetingUrl + "/" + item?._id, {
                                    replace: false,
                                  });
                                }}>
                                <div className='flex flex-col'>
                                  <div>
                                    <h4 className='text-gray-dark font-semibold text-sm tracking-wide pl-2 pt-1'>
                                      #{item?.customerID} | {item?.customerType}
                                    </h4>
                                  </div>
                                  <div
                                    onClick={(e) => {
                                      navigate(meetingUrl + "/" + item?._id, {
                                        replace: false,
                                      });
                                    }}>
                                    <h4 className='text-gray-dark font-normal text-sm tracking-wide pl-2 pt-1 text-left'>
                                      {item?.prefix}.&nbsp;
                                      {item?.firstName}&nbsp;
                                      {item?.lastName ? item?.lastName : ""}
                                    </h4>
                                  </div>
                                  <div
                                    onClick={(e) => {
                                      navigate(meetingUrl + "/" + item?._id, {
                                        replace: false,
                                      });
                                    }}>
                                    <div>
                                      <h4 className='text-gray-dark font-normal text-sm tracking-wide pl-2 pt-0 text-left'>
                                        {"" + item?.countryCode}&nbsp;
                                        {item?.phoneNumber}
                                      </h4>
                                    </div>
                                  </div>
                                  <div className='text-gray-dark font-normal text-sm tracking-wide pl-2 pt-0 text-left'>
                                    {item?.email
                                      ? item?.email.length > 25
                                        ? item?.email.slice(0, 15) +
                                          "..." +
                                          item?.email.slice(-7)
                                        : item?.email
                                      : "--"}
                                  </div>
                                </div>
                              </div>
                              <div className='col-span-2'>
                                <div className='flex flex-col'>
                                  <div
                                    onClick={(e) => {
                                      navigate(meetingUrl + "/" + item?._id, {
                                        replace: false,
                                      });
                                    }}>
                                    <h4 className='text-gray-dark font-bold text-xs tracking-wide pr-2 pt-1 text-right'>
                                      {item?.crm?.fullname &&
                                      item?.crm?.fullname !== ""
                                        ? item.crm.fullname
                                        : item?.crm?.firstname}
                                    </h4>
                                  </div>
                                </div>
                              </div>
                              <div className='col-span-3'></div>
                              <div className='col-span-6'>
                                {item?.createdBy === state.user._id ||
                                  (state.user.department !== undefined &&
                                    state.user.department?.name === "CRM") ||
                                  (["admin", "super-admin"].includes(
                                    state.user.aclGroup,
                                  ) && (
                                    <div className='pb-1 pr-3 right-0'>
                                      <div className='grid grid-cols-6 gap-2'>
                                        <div className='col-span-4'></div>
                                        <div className=''>
                                          <Link
                                            to={`/meetings/edit/${item?._id}`}>
                                            <h4 className='font-semibold text-base text-yellow-2 text-right pr-2'>
                                              Edit
                                            </h4>
                                          </Link>
                                        </div>
                                        <div className=''>
                                          <h4
                                            onClick={() => {
                                              confirmDelete(item?._id);
                                            }}
                                            className='font-semibold text-base text-red-600 text-right pr-2'>
                                            Delete
                                          </h4>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                              </div>
                            </div>
                          </div>
                        ))}
                        {meetingData.length > 0 && (
                          <Pagination
                            pages={totalPages}
                            currentPage={currentPageIndex}
                            recordsPerPage={recordsPerPage}
                            changePageCallback={changePageCallback}
                            totalRecords={totalRecords}
                            changeDisplayRecordCountCallback={
                              changeDisplayRecordCountCallback
                            }
                          />
                        )}
                      </div>
                    ) : (
                      <div className='px-3 py-2'>
                        <h4 className='text-lg font-semibold'>
                          No data to display
                        </h4>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className='grid grid-cols-1 gap-4 '>
                    <div className='flex animate-pulse flex-col items-left h-full justify-center border-b-2 pb-1 border-gray-100'>
                      <div className='flex flex-row gap-2'>
                        <div className='w-5/12 bg-yellow-2 h-6 rounded-md '></div>
                        <div className='w-7/12 bg-gray-200 h-6 rounded-md '></div>
                      </div>
                      <div className='w-full bg-gray-100 h-4 rounded-md mt-2 '></div>
                      <div className='w-full bg-gray-100 h-4 rounded-md mt-2 '></div>
                      <div className='flex flex-row gap-2 mt-2'>
                        <div className='w-8/12 bg-gray-100 h-8 rounded-md '></div>
                        <div className='w-4/12 bg-yellow-2 h-8 rounded-md '></div>
                      </div>
                    </div>
                    <div className='flex animate-pulse flex-col items-left h-full justify-center mt-1 border-b-2 pb-1 border-gray-100'>
                      <div className='flex flex-row gap-2'>
                        <div className='w-5/12 bg-yellow-2 h-6 rounded-md '></div>
                        <div className='w-7/12 bg-gray-200 h-6 rounded-md '></div>
                      </div>
                      <div className='w-full bg-gray-100 h-4 rounded-md mt-2 '></div>
                      <div className='w-full bg-gray-100 h-4 rounded-md mt-2 '></div>
                      <div className='flex flex-row gap-2 mt-2'>
                        <div className='w-8/12 bg-gray-100 h-8 rounded-md '></div>
                        <div className='w-4/12 bg-yellow-2 h-8 rounded-md '></div>
                      </div>
                    </div>
                    <div className='flex animate-pulse flex-col items-left h-full justify-center mt-1 border-b-2 pb-1 border-gray-100'>
                      <div className='flex flex-row gap-2'>
                        <div className='w-5/12 bg-yellow-2 h-6 rounded-md '></div>
                        <div className='w-7/12 bg-gray-200 h-6 rounded-md '></div>
                      </div>
                      <div className='w-full bg-gray-100 h-4 rounded-md mt-2 '></div>
                      <div className='w-full bg-gray-100 h-4 rounded-md mt-2 '></div>
                      <div className='flex flex-row gap-2 mt-2'>
                        <div className='w-8/12 bg-gray-100 h-8 rounded-md '></div>
                        <div className='w-4/12 bg-yellow-2 h-8 rounded-md '></div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default Meetings;
